export const PENDING_POLL_INTERVAL_MS = 600;
export const PENDING_TIMEOUT_MS = 15_000;

// Tagging as INSURANCE triggers a server-side auto-match that emits a second
// CRUD event; hold the indicator open this long so it has time to land.
export const AUTO_MATCH_SETTLE_WINDOW_MS = 3_000;

export type PendingExpectation = {
  expected: Partial<BankTransactionMessage>;
  minSettleDurationMs?: number;
};

export type PendingMutation = {
  wieldyId: string;
  expected: Partial<BankTransactionMessage>;
  minSettleDurationMs?: number;
  startedAt: number;
};

export function expectedFromUpdate(
  update: BankTransactionUpdateMessage,
): PendingExpectation {
  const expected: Partial<BankTransactionMessage> = {};
  if (update.status !== undefined) expected.status = update.status ?? null;
  if (update.transactionType !== undefined)
    expected.transactionType = update.transactionType ?? null;
  if (update.paymentKey !== undefined)
    expected.paymentKey = update.paymentKey ?? null;
  // Backend forces MANUALLY_MATCHED when paymentKey is set without an explicit status.
  if (update.paymentKey && update.status === undefined) {
    expected.status = "MANUALLY_MATCHED";
  }

  const triggersAutoMatch =
    (update.transactionType as unknown as string) === "INSURANCE" &&
    !update.paymentKey;

  return triggersAutoMatch
    ? { expected, minSettleDurationMs: AUTO_MATCH_SETTLE_WINDOW_MS }
    : { expected };
}

export function fieldsMatch(
  server: BankTransactionMessage,
  expected: Partial<BankTransactionMessage>,
): boolean {
  const keys = Object.keys(expected) as (keyof BankTransactionMessage)[];
  // ?? null on both sides so server `undefined` matches expected `null`.
  return keys.every((key) => (server[key] ?? null) === (expected[key] ?? null));
}
